import logo from './logo.svg';
import './App.css';
import Intro from './Work/Intro';
import FetchImage from './Work/Image';
import Reg_link from './Work/Reg_link';
import Component1 from './Node_js/Component1';
import Socket from './Node_js/Socket';
import EncryptComponent from './Node_js/Encryption';

import { Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Intro />
    </div>
  );
}

export default App;
